import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { LiteSlateEditor } from "../../lite-slate-editor"
import { getRatio } from "../../components/column-ratio"

const DEFAULT_IMAGE_URL =
  "https://cdn.convertkit.com/assets/layout-placeholder-v2.png"

const styles = `
  @media only screen and (max-width:600px) {
    .ck-ctaleftheaderimageright td {
      display: block !important;
      width: 100% !important;
      padding: 0 !important;
    }

    .ck-ctaleftheaderimageright img {
      margin-top: 18px !important;
    }
  }
`

export function CTALeftHeaderImageRight({ block_id, properties }) {
  const { children } = useBlocks(block_id)
  const imageHeight = 210 // this height was taken from designs/figma

  const containerStyle = {
    backgroundColor: properties.backgroundColor,
    borderTopLeftRadius: properties.borderTopLeftRadius,
    borderTopRightRadius: properties.borderTopRightRadius,
    borderBottomLeftRadius: properties.borderBottomLeftRadius,
    borderBottomRightRadius: properties.borderBottomRightRadius,
    borderWidth: properties.borderWidth,
    borderTopWidth: properties.borderTopWidth,
    borderRightWidth: properties.borderRightWidth,
    borderBottomWidth: properties.borderBottomWidth,
    borderLeftWidth: properties.borderLeftWidth,
    borderColor: properties.borderColor,
    borderStyle: "solid",
    overflow: "hidden",
    marginTop: properties.marginTop,
    marginBottom: properties.marginBottom
  }

  // console.log(properties.marginTop)

  const contentStyle = {
    paddingTop: properties.verticalPadding,
    paddingRight: properties.horizontalPadding,
    paddingBottom: properties.verticalPadding,
    paddingLeft: properties.horizontalPadding
  }

  return (
    <div
      className="ck-ctaleftheaderimageright ck-layout-block-template"
      style={containerStyle}
      bgcolor={properties.backgroundColor}
    >
      <table
        border="0"
        cellPadding="0"
        cellSpacing="0"
        width="100%"
        bgcolor={properties.backgroundColor}
      >
        <tbody>
          <tr>
            <td
              width={getRatio(properties.columnRatio, "left")}
              style={{
                verticalAlign: "middle",
                paddingLeft: properties.paddingLeft,
                paddingRight: properties.paddingRight,
                paddingTop: properties.paddingTop,
                paddingBottom: properties.paddingBottom
              }}
            >
              <div style={contentStyle}>
                <LiteSlateEditor block_id={children[0].block_id} />
              </div>
            </td>
            <td
              height={imageHeight}
              width={getRatio(properties.columnRatio, "right")}
              style={{
                backgroundImage: `url(${properties.image ||
                  DEFAULT_IMAGE_URL})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: properties.imageBorderRadius,
                overflow: "hidden"
              }}
            />
          </tr>
        </tbody>
      </table>
      <style>{styles}</style>
    </div>
  )
}
